/* eslint-disable react-hooks/rules-of-hooks */
import { Platform, ViewStyle } from 'react-native';

import { mediaQueryValues } from './media-query';

const mediaQuery = mediaQueryValues();

// padding
export const extraSmallPaddingBox: ViewStyle = {
  padding: mediaQuery.extraSmall,
};

export const smallPaddingBox: ViewStyle = {
  padding: mediaQuery.small,
};
export const mediumPaddingBox: ViewStyle = {
  padding: mediaQuery.medium,
};

export const largePaddingBox: ViewStyle = {
  padding: mediaQuery.large,
};

export const extraLargePaddingBox: ViewStyle = {
  padding: mediaQuery.extraLarge,
};

// paddingTop
export const extraSmallPaddingTopBox: ViewStyle = {
  paddingTop: mediaQuery.extraSmall,
};

// paddingHorizontal

export const extraSmallPaddingHorizontalOptionButton: ViewStyle = {
  paddingHorizontal: mediaQuery.extraSmall / 2,
};

export const smallPaddingHorizontalBox: ViewStyle = {
  paddingHorizontal: mediaQuery.small,
};

export const mediumPaddingHorizontalBox: ViewStyle = {
  paddingHorizontal: mediaQuery.medium,
};

export const largePaddingHorizontalBox: ViewStyle = {
  paddingHorizontal: mediaQuery.large,
};

// marginHorizontal

export const extraSmallMarginHorizontalBox: ViewStyle = {
  marginHorizontal: mediaQuery.extraSmall,
};

// paddingVertical

export const extraSmallPaddingVerticalOptionButton: ViewStyle = {
  paddingVertical: mediaQuery.extraSmall / 2,
};

export const extraSmallPaddingVerticalBox: ViewStyle = {
  paddingVertical: mediaQuery.extraSmall,
};

export const smallPaddingVerticalBox: ViewStyle = {
  paddingVertical: mediaQuery.small,
};

export const mediumPaddingVerticalBox: ViewStyle = {
  paddingVertical: mediaQuery.medium,
};

// paddingBottom
export const extraSmallPaddingBottomBox: ViewStyle = {
  paddingBottom: mediaQuery.extraSmall,
};

export const smallPaddingBottom: ViewStyle = {
  paddingBottom: mediaQuery.small,
};

export const largePaddingBottom: ViewStyle = {
  paddingBottom: mediaQuery.large,
};

// marginTop
export const extraSmallNegativeMarginTopBox: ViewStyle = {
  marginTop: -mediaQuery.extraSmall,
};

export const mediumNegativeMarginTopBox: ViewStyle = {
  marginTop: -mediaQuery.medium,
};

export const largeNegativeMarginTopBox: ViewStyle = {
  marginTop: -mediaQuery.large,
};

export const extraLargeNegativeMarginTopBox: ViewStyle = {
  marginTop: -mediaQuery.extraLarge,
};

export const smallMarginTopBox: ViewStyle = {
  marginTop: mediaQuery.small,
};

// marginBottom
export const extraSmallMarginBottomBox: ViewStyle = {
  marginBottom: mediaQuery.extraSmall,
};

export const mediumNegativeMarginBottomBox: ViewStyle = {
  marginBottom: -mediaQuery.medium,
};

export const extraLargeNegativeMarginBottomBox: ViewStyle = {
  marginBottom: -mediaQuery.extraLarge,
};

export const extraSmallMarginVertical: ViewStyle = {
  marginVertical: mediaQuery.extraSmall,
};

// rounded
export const roundedBox: ViewStyle = {
  borderRadius: 6,
};

export const roundedButton: ViewStyle = {
  borderRadius: 32,
};

// Border
export const dashedBorderBox: ViewStyle = {
  borderStyle: 'dashed',
  borderWidth: 2,
};

export const borderBox: ViewStyle = {
  borderWidth: 2,
};

// flex
export const row: ViewStyle = {
  flexDirection: 'row',
};

export const column: ViewStyle = {
  flexDirection: 'column',
};

// align
export const contentApart: ViewStyle = {
  justifyContent: 'space-between',
};

export const centeredBox: ViewStyle = {
  alignItems: 'center',
  justifyContent: 'center',
};

export const centeredRowBox: ViewStyle = {
  ...row,
  ...centeredBox,
};

// shadow
export const shadowButton: ViewStyle = {
  shadowOffset: { width: 0, height: 2 },
};

export const button = {
  ...roundedBox,
  ...borderBox,
  ...centeredBox,
  ...smallPaddingHorizontalBox,
  paddingVertical: 6,
  borderBottomWidth: 4,
};

//button proportions

export const buttonProportionsLarge: ViewStyle = {
  height: 1.5 * mediaQuery.extraLarge,
  width: 1.5 * mediaQuery.extraLarge,
};

export const noOutline =
  Platform.OS === 'web'
    ? {
        outlineWidth: 0,
      }
    : {};
